import React from 'react';
import { createRoot } from 'react-dom/client';
//import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import history from './store/history';
import 'styles/index.css';
//import version from "./buildversion.json";
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setDb, openDatabase } from 'store/idb';
import { waitForSleep } from 'helpers/generalHelpers';
import { getAppState, updateAppState, setStateInstalled, setStateStandalone } from 'store/storeValtio';
import { clearData } from 'helpers/storageHelpers';
//import { getAPI } from 'helpers/apiHelpers';
import { initializeOrangeBook } from './drugData/orangeBookService';

export function saveAppState() {
  var appState = getAppState();
  appState.loaded = true;
  localStorage.setItem('appState', JSON.stringify(appState));
  //console.log('saveAppState', appState);
}

function loadAppState() {
  var as = localStorage.getItem('appState');
  if (as === null) {
    const gas = getAppState();
    as = JSON.stringify(gas);
  }
  var appState = JSON.parse(as);
  appState.loaded = true;
  updateAppState(appState);
  //console.log('loadAppState', appState);
  return getAppState();
}

const closeApp = localStorage.getItem('closeApp');
//console.log('index.js', closeApp);
//console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`);

//console.log('document', document);
if (closeApp && closeApp === 'true') {
  //console.log('closeApp');
  localStorage.removeItem('closeApp');
  const href = 'https://itookitwhen.com/close.html';
  window.open(href, "_top");
} else {

//const appState = loadAppState();
//console.log('appState', appState)

let installPrompt = null;
//const installButton = document.querySelector("#install");

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  installPrompt = event;
  //console.log('beforeinstallprompt', installPrompt);
  setStateInstalled(false);
  //installButton.removeAttribute("hidden");
});

// do action when finished install
window.addEventListener('appinstalled', (event) => {
  //console.log("appinstalled", event);
  setStateInstalled(true);
  saveAppState();
  //getAPI('install');  // log the install
});

// do action when uninstall
window.addEventListener('appuninstalled', (event) => {
  //console.log("appuninstalled", event);
  clearData();
  //getAPI('uninstall');  // log the uninstall
});

var wait = false;
async function openDb() {
  wait = true;
  //console.log('openDb');
  const response = await openDatabase();
  setDb(response);
  //console.log('DB Opened', response);
  wait = false;
}
//function waiting() {console.log('waiting');}

openDb();
// wait until the DB is open
while (wait) {
  await waitForSleep(100);
};

//const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
//console.log('Chrome: ', raw);

//console.log('Version', version);

const location = window.location.href;
const lh = location.includes('localhost');
//console.log('localhost', location, lh);

if (!('serviceWorker' in navigator)) {
  console.log('serviceWorker NOT supported!');
} else {
  console.log('serviceWorker supported!');
}

if (!('PushManager' in window)) {
  console.log('PushManager NOT supported on this browser!');
} else {
  console.log('PushManager supported!');
}

if (!lh) {
  //console.log('before register');
  serviceWorkerRegistration.register();
  //console.log('after register');
} else {
  console.log('not registering ServiceWorker');
}

const standalone = (window.matchMedia('(display-mode: standalone)').matches);
setStateStandalone(standalone);
saveAppState();
//console.log('standalone', standalone);
await initializeOrangeBook();

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Router history={history} >
    <App />
  </Router>
);
}